export const BUTTON_VARIANT_SECONDARY = 'variant_secondary';
export const VARIANT_BUTTON_NO_OUTLINE = 'variant_tertiary';
export const BUTTON_VARIANT_LINK = 'variant_link';
export const BUTTON_VARIANT_DARK = 'variant_dark';
export const BUTTON_VARIANT_SUCCESS = 'variant_success';
export const BUTTON_VARIANT_LIGHT = 'variant_light';
